import React, {
  useEffect,
  useCallback,
  useContext,
  useState,
  useRef,
} from "react";
import { UserContext } from "context/user";
import { MapContext } from "context/map";
import { getFieldsStatistics } from "api/Algorithm";
import "./index.scss";

const Legend = () => {
  const legend = useRef();
  const [statistics, setStatistics] = useState(null);
  const { token } = useContext(UserContext);
  const { state } = useContext(MapContext);
  const { selectedLayer, selectedAlgorithm, selectedFields, selectedDate } =
    state;

  const algorithm = useCallback(() => {
    switch (selectedLayer) {
      case "high_res":
        return `high_res_${selectedAlgorithm.toLowerCase()}`;
      case "sensor_em":
        return `sensor_em_${selectedAlgorithm.toLowerCase()}`;
      default:
        return `standard_${selectedAlgorithm.toLowerCase()}`;
    }
  }, [selectedAlgorithm, selectedLayer]);

  const fetchStatistics = useCallback(async () => {
    const fieldsQuery = selectedFields
      .map((field) => `field_ids=${field}`)
      .join("&");
    const query = `${algorithm()}/statistics.json?color_stretch=dynamic&${fieldsQuery}&latest_capture_date=${selectedDate}`;
    const statisticsData = await getFieldsStatistics(query, token);

    setStatistics(statisticsData);
  }, [algorithm, selectedDate, selectedFields, token]);

  const generateLegend = useCallback(() => {
    const rgba = statistics.color_rendering.color_range
      .map((item) => `rgba(${item[0]},${item[1]},${item[2]},1)`)
      .join(", ");
    legend.current.style.background = `linear-gradient(to right, ${rgba})`;
  }, [statistics]);

  useEffect(() => {
    if (selectedDate) {
      fetchStatistics();

      return;
    }

    setStatistics(null);
  }, [fetchStatistics, selectedDate]);

  useEffect(() => {
    if (statistics) {
      if (selectedAlgorithm !== "COLOUR" && selectedAlgorithm !== "THERMAL") {
        generateLegend();
      }
    }
  }, [generateLegend, statistics, selectedAlgorithm]);

  if (!statistics) return null;

  const renderLegend = () => (
    <div className="legend">
      <div ref={legend} className="legend-wrapper" />
      <div className="label">
        <div>{Math.round(statistics.min * 100) / 100}</div>
        <div>{Math.round(statistics.mean * 100) / 100}</div>
        <div>{Math.round(statistics.max * 100) / 100}</div>
      </div>
    </div>
  );

  return (
    <div>
      {selectedAlgorithm === "COLOUR" || selectedAlgorithm === "THERMAL"
        ? null
        : renderLegend()}
    </div>
  );
};

export default Legend;
